export const MOTIVOS_DE_INTERRUPCAO = Object.freeze({
  FALHA_AO_INICIAR: 'falha_ao_iniciar',
  ROTA_INVALIDA: 'rota_invalida',
  ROTA_COM_CURINGA: 'rota_com_curinga',
  PULOS_ESGOTADOS: 'pulos_esgotados',
  ULTIMO_PASSO_SEM_ALVO: 'ultimo_passo_sem_alvo',
  NENHUM_PASSO_ANTERIOR_ALCANCAVEL: 'nenhum_passo_anterior_alcancavel',
  ALVO_NAO_ENCONTRADO: 'alvo_nao_encontrado',
  ALVO_PRESENTE_MAS_INVISIVEL: 'alvo_presente_mas_invisivel',
  NAVEGACAO_SEM_SUCESSO: 'navegacao_sem_sucesso',
  NAVEGACAO_PELA_ACAO_NAO_OCORREU: 'navegacao_pela_acao_nao_ocorreu',
  NAVEGACAO_BARRADA_POR_VALIDACAO: 'navegacao_barrada_por_validacao',
  ERRO_NO_ENVIO_DO_FORMULARIO: 'erro_no_envio_do_formulario',
  MODAL_FECHADA_COM_ERRO_DE_ENVIO: 'modal_fechada_com_erro_de_envio'
})

export const ACOES_DO_TOUR = Object.freeze({
  INICIO: 'inicio',
  RETOMADA: 'retomada',
  PROXIMO: 'proximo',
  ANTERIOR: 'anterior',
  PULO: 'pulo',
  CLIQUE_NO_ALVO: 'clique_no_alvo'
})

const SENTRY_ERRO = 'error'
const SENTRY_AVISO = 'warning'

export const DESTINOS_POR_MOTIVO = Object.freeze({
  [MOTIVOS_DE_INTERRUPCAO.FALHA_AO_INICIAR]: { sentry: SENTRY_ERRO, posthog: false },
  [MOTIVOS_DE_INTERRUPCAO.ROTA_INVALIDA]: { sentry: SENTRY_ERRO, posthog: false },
  [MOTIVOS_DE_INTERRUPCAO.ROTA_COM_CURINGA]: { sentry: SENTRY_ERRO, posthog: false },
  [MOTIVOS_DE_INTERRUPCAO.PULOS_ESGOTADOS]: { sentry: SENTRY_ERRO, posthog: false },
  [MOTIVOS_DE_INTERRUPCAO.ULTIMO_PASSO_SEM_ALVO]: { sentry: SENTRY_ERRO, posthog: false },
  [MOTIVOS_DE_INTERRUPCAO.NENHUM_PASSO_ANTERIOR_ALCANCAVEL]: { sentry: SENTRY_ERRO, posthog: false },
  [MOTIVOS_DE_INTERRUPCAO.ALVO_NAO_ENCONTRADO]: { sentry: SENTRY_AVISO, posthog: true },
  [MOTIVOS_DE_INTERRUPCAO.ALVO_PRESENTE_MAS_INVISIVEL]: { sentry: SENTRY_AVISO, posthog: true },
  [MOTIVOS_DE_INTERRUPCAO.NAVEGACAO_SEM_SUCESSO]: { sentry: SENTRY_AVISO, posthog: true },
  [MOTIVOS_DE_INTERRUPCAO.NAVEGACAO_PELA_ACAO_NAO_OCORREU]: { sentry: SENTRY_ERRO, posthog: false },
  [MOTIVOS_DE_INTERRUPCAO.NAVEGACAO_BARRADA_POR_VALIDACAO]: { sentry: null, posthog: true },
  [MOTIVOS_DE_INTERRUPCAO.ERRO_NO_ENVIO_DO_FORMULARIO]: { sentry: null, posthog: true },
  [MOTIVOS_DE_INTERRUPCAO.MODAL_FECHADA_COM_ERRO_DE_ENVIO]: { sentry: null, posthog: true }
})

export const EVENTO_POSTHOG_INTERRUPCAO = 'tour_guiado_interrompido'
export const FLUXO_SENTRY_TOUR_GUIADO = 'tour_guiado'
export const PREFIXO_FINGERPRINT_TOUR_GUIADO = 'tour-guiado'

export class ErroConfiguracaoTourGuiado extends Error {
  constructor(motivo) {
    super(`Tour guiado interrompido: ${motivo}`)
    this.name = 'ErroConfiguracaoTourGuiado'
    this.motivo = motivo
  }
}

export function montarDadosDaInterrupcao({ tour, indicePasso, acao }) {
  const passos = Array.isArray(tour?.passos) ? tour.passos : []
  const passo = passos[indicePasso] || {}

  return {
    tour_id: tour?.id ?? null,
    tour_nome: tour?.nome ?? null,
    indice_passo: indicePasso,
    total_passos: passos.length,
    seletor_alvo: passo.seletor_alvo || null,
    rota_pattern: passo.rota_pattern || tour?.rota_pattern || null,
    rota_atual: window.location.pathname,
    acao
  }
}
